import { render, staticRenderFns } from "./LandingVideo.vue?vue&type=template&id=09ca3b4e"
import script from "./LandingVideo.vue?vue&type=script&lang=js"
export * from "./LandingVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports